import "@/App.css";
import { LanguageProvider } from "./context/LanguageContext";
import { Navigation } from "./components/Navigation";
import { Hero } from "./components/sections/Hero";
import { Philosophy } from "./components/sections/Philosophy";
import { SolutionPillars } from "./components/sections/SolutionPillars";
import { MaxFramework } from "./components/sections/MaxFramework";
import { Blueprints } from "./components/sections/Blueprints";
import { Ecosystem } from "./components/sections/Ecosystem";
import { FeaturedUseCase } from "./components/sections/FeaturedUseCase";
import { Services } from "./components/sections/Services";
import { WhyMax } from "./components/sections/WhyMax";
import { Insights } from "./components/sections/Insights";
import { Contact } from "./components/sections/Contact";
import { Footer } from "./components/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-white text-[#0B1F3A]">
        <Navigation />
        <main>
          <Hero />
          <Philosophy />
          <SolutionPillars />
          <MaxFramework />
          <Blueprints />
          <Ecosystem />
          <FeaturedUseCase />
          <Services />
          <WhyMax />
          <Insights />
          <Contact />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
